/**
 * Google AdWords audience integration
 * @module
 */
var BrowserSource = require('core/utils/browser');



var VENDOR = 'google_adwords';
var CAMPAIGN_ID_PARAM_NAME = 'opti_ca';
var AD_GROUP_ID_PARAM_NAME = 'opti_ag';
var AD_ID_PARAM_NAME = 'opti_ad';
var KEYWORD_ID_PARAM_NAME = 'opti_key';
var TRACKING_IDENTIFIER = 'opti_source';
var VALUE_DELIMITER = ':';

var pluginAudienceAdwords: AudiencePluginConfig = {
  provider: {
    getter: [
      'stores/visitor',
      function(VisitorStore) {
        var params = {} as any;
        var queryParams = BrowserSource.getQueryParams();
        var storedData = VisitorStore.getAttribute('vendor.' + VENDOR) || {campaign: [], adgroup: [], ad: [], keyword: []};

        for (var i = 0; i < queryParams.length; i++) {
          params[queryParams[i][0]] = queryParams[i][1];
        }

        if (params[CAMPAIGN_ID_PARAM_NAME] &&
            params[AD_GROUP_ID_PARAM_NAME] &&
            params[AD_ID_PARAM_NAME] &&
            !params[TRACKING_IDENTIFIER]) {
          // All IDs shall already be URI component encoded.
          // Adwords is the only ad integration in which we do NOT look for opti_source
          // due to it being the first.

          var campaignId = params[CAMPAIGN_ID_PARAM_NAME];
          var adGroupId = [params[CAMPAIGN_ID_PARAM_NAME], params[AD_GROUP_ID_PARAM_NAME]].join(VALUE_DELIMITER);
          var adId = [params[CAMPAIGN_ID_PARAM_NAME], params[AD_GROUP_ID_PARAM_NAME], params[AD_ID_PARAM_NAME]].join(VALUE_DELIMITER);

          if (storedData.campaign.indexOf(campaignId) === -1) {
            storedData.campaign.push(campaignId);
          }

          if (storedData.adgroup.indexOf(adGroupId) === -1) {
            storedData.adgroup.push(adGroupId);
          }

          if (storedData.ad.indexOf(adId) === -1) {
            storedData.ad.push(adId);
          }

          if (params[KEYWORD_ID_PARAM_NAME]) {
            // This regex matches non-zero number of digits prefixed with 'kwd-'
            // that terminates with an optional ';' or '&'
            var re = /(kwd\-(\d+))[\:\&]?/g, match = null, keywords = [];
            while ((match = re.exec(params[KEYWORD_ID_PARAM_NAME])) !== null) {
              keywords.push(match[2]);
            }
            if (keywords.length > 0) {
              var keywordId = [params[AD_GROUP_ID_PARAM_NAME], keywords[0]].join(VALUE_DELIMITER);
              if (storedData.keyword.indexOf(keywordId) === -1 ) {
                storedData.keyword.push(keywordId);
              }
            }
          }

          return storedData;
        }
      },
    ]
  },
  matcher: require('core/plugins/matchers/key_value'),
  vendor: VENDOR,
};

module.exports = function(PluginManager) {
  PluginManager.registerAudiencePlugin(pluginAudienceAdwords);
};

if (__TEST__) {
  module.exports.plugin = pluginAudienceAdwords;
}
